import { NativeMountingID, PartnerAccessoriesID } from '../../../../../../../types/mounting'
import {
  K2CrossrailEngineeringSchema,
  K2SchemaMap,
  K2SimpleTiltEngineeringSchema,
} from './mounting_systems/K2US/K2APISchema'

export const nativeRailSystems: NativeMountingID[] = [
  'sunmodoSMRPitched',
  'sunmodoNanoRack',
  'solarRoofPro',
  'solarNestRooftop',
  'vanDerValk',
  'solarNestGroundMount',
  'variosole',
  'schletter',
  'fastensol',
  'msPitchedProLine',
  'msTrapezeProLine',
  'metasole',
  'k2OnRoofUK',
  'nova',
  'fastRack',
]

export const nativeMountingIDs: NativeMountingID[] = [
  ...nativeRailSystems,
  'esdec',
  'flatFix',
  'gseInRoof',
  'k2OnRoof',
  'k2SimpleTilt',
  'k2GroundMount',
  'k2OnRoofUK',
  'snapnrackUltraRail',
]

export const partnerAccessoriesIDs: PartnerAccessoriesID[] = ['solaskirt']

export const DEFAULT_MOUNTING_SPACING_INCHES = 48

export const possibleInputVariables = [
  'roofHookCalculationMethod',
  'railDirection',
  'railDirectionLandscapePanels',
  'railDirectionPortraitPanels',
  'mountingSpacing',
  'mountingSpacingInches',
  'railLength',
  'colour',
  'railColour',
  'clampColour',
  'endCapColour',
  'roofHook',
  'roofHookPortrait',
  'roofHookLandscape',
  'geniusKit',
  'mountingRail',
  'railSplice',
  'midClamp',
  'endClamp',
  'horizontalEndClamp',
  'verticalEndClamp',
  'fastener',
  'endCap',
  'profile',
  'panelThicknessRange',
  'terrainCategory',
  'windSpeed',
  'system',
  'tpoMats',
  'rowDistance',
  'roofHeight',
  'blackArticles',
  'includeRoofAdapter',
  'roofRibDistance',
  'seamType',
  'flangeDistance',
  'panelConfiguration',
  'roofHookMaterial',
  'clampQty',
  'topConnection',
  'flexibleStrip',
  'rearSupportBarIncluded',
  'chimneyQty',
  'attachmentType',
  'mountType',
  'conduitMountQty',
  'conduitMount',
  'wireClipQty',
  'mlpeMount',
  'skirtConfiguration',
  'clampPlacement',
  'k2UKRailType',
  'tiltOption',
  'soilType',
  'frostLineDepth',
  'groundClearance',
  'groundSlope',
  'portraitConfig',
  'postType',
  'relativeTilt',
  'foundation',
  'windZone',
  'snowZone',
  'distanceToShorelineKM',
  'parapetHeightM',
  'roughnessFactor',
  'turbulenceIntensity',
  'arraySpacing',
  'channels',
  'railType',
  'railOrientation',
  'componentColour',
  'corrugatedRoof',
  'kliplokBracket',
  'footSpacing',
  'extraLength',
  'useIsolatorCovers',
  'anchorType',
  'clampStyle',
  'hiddenClamp',
  'pestProtection',
  'fenceHeight',
  'fenceAttachment',
  'endCaps',
  'cableClipQty',
  'rtMiniCalcSpan',
  'seamSpacing',
  'majorRibSpacing',
  'snowLoad',
  'snowSs_kPa',
  'snowSr_kPa',
  'sparePartsPercent',
  'preferredRails',
  'isCorrugated',
  'exposure',
  // SnapNRack UltraRail — main inputs
  'railRun',
  'prioritiseDomesticContent',
  'spliceFinish',
  'mountingType',
  'attachment',
  'universalSkirtRail',
  'skirtRailSpacer',
  'cableManagers',
  'designSnowLoad',
  // SnapNRack UltraRail — PZSE dialog
  'roofStructureType',
  'asce7Version',
  'thermalFactor',
  'roomToSlide',
  'slipperySurface',
  'reducibleSnowLoad',
  'snowExposure',
  'windExposure',
  'rafterSpacing',
  'meanRoofHeight',
  'leastHorizontalBuildingDimension',
  'attachmentSpacingInches',
  ...Object.values(K2SchemaMap).flatMap((schema) => Object.keys(schema.properties)),
  ...Object.keys(K2CrossrailEngineeringSchema.properties),
  ...Object.keys(K2SimpleTiltEngineeringSchema.properties),
] as const
